import { RouterRootState } from 'connected-react-router';
import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import { useDialog } from '../../../components/dialog/DialogContext';
import { Topic } from '../../../components/item-content-two/Topic';
import ItemContentTabTwo from '../../../components/item-content-two/item-content-tab_two';
import SimpleItemDetails from '../../../components/item-content/SimpleItemDetails';
import ReasonCodeCard from "../../../components/reasonCode/ReasonCodeCard";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useLocale } from "../../../contexts/localeContext";
import { TopicContextProvider } from '../../../contexts/topic/TopicContextProvider';
import { BreadcrumbLink } from "../../../models/BreadcrumbLink";
import { MultiSelectOption } from '../../../models/MultiSelectOption';
import { ReasonCode as ReasonCodeModel } from '../../../models/ReasonCode';
import { getReasonCodeById, getReasonCodesNameWithPagination, storeReasonCode } from '../../../services/reasonCodeService';
import { getErrorMessage, showLoadItemError } from '../../../services/utilities/ServiceError';

const getIdFromPath = (path: string) => {
    const splitPath = path.split('/');
    return splitPath[splitPath.length - 1];
}

const initialItem : ReasonCodeModel = {
    name: '',
    slot: '',
    id: 0
}

const allItemsPath = '/access-control/hardware/reason-codes';
const itemPath = '/access-control/hardware/reason-code/';

const ReasonCode: FC = () => {
    const { translate } = useLocale();
    const history = useHistory();
    const pageId = useSelector((state: RouterRootState) => getIdFromPath(state.router.location.pathname));
    const [itemId, setItemId] = useState(pageId);
    const [currentItem, setCurrentItem] = useState<ReasonCodeModel>(initialItem);
    const [breadcrumb, setBreadcrumb] = useState<BreadcrumbLink[]>([]);
    const [busy, setBusy] = useState(false);
    const dialog = useDialog();
    const [selectedItem, setSelectedItem] = useState<MultiSelectOption | undefined>(undefined);

    const reloadPage = async () => {
        try {
            let reasonCode;

            if (itemId) {
                reasonCode = await getReasonCodeById(itemId);

                setSelectedItem({label: reasonCode.name, value: reasonCode.id.toString()})
                setCurrentItem(reasonCode);
            }
            else{
                setCurrentItem(initialItem);
            }

            setBreadcrumb([
                { value: '/access-control/hardware', displayName: translate.byKey(TranslationKeys.hardware) },
                { value: allItemsPath, displayName: translate.byKey(TranslationKeys.reasonCodes) },
                { value: itemPath + `${itemId}`, displayName: `${reasonCode?.name ?? ''}` }
            ]);
        } catch (error) {
            showLoadItemError(error, dialog, translate, () => { history.push(allItemsPath) });
        }
    }

    const topic: Topic = {
        accessor: 'arcDesc',
        title: translate.byKey(TranslationKeys.reasonCodes),
        allItemsPath: allItemsPath,
        itemPath: itemPath
    }

    const saveReasonCode = (values) => {
        const newReasonCode = {
            ...currentItem,
            name: values.name,
        }

        const isNew = pageId ? false : true;
        saveItem(setBusy, storeReasonCode, newReasonCode, isNew, setItemId, history)
    }

    const saveItem = (setBusy, storeMethod, item, createNewItem, setItemId, history) => {
        setBusy(true);
        storeMethod(item, createNewItem)
            .then(async (value) => {
                setItemId(value.id);
                history.push(`${itemPath}${value.id}`);
                // dispatch(FetchDataAction_old());
                reloadPage();//Added this because the page doesn't have tabs so we have to tell it to update
                toast.success(translate.byKey(TranslationKeys.reasonCodeSaved));
            })
            .catch(failure => {
                dialog.pushError({ title: translate.byKey(TranslationKeys.error), message: getErrorMessage(failure) });
            })
            .finally(() => {
                setBusy(false);
            });
    }

    useEffect(() => {
        reloadPage();
    }, [])

    useEffect(() => {
        setItemId(pageId);
    }, [pageId])

    useEffect(() => {
        reloadPage();
    }, [itemId])

    return <TopicContextProvider itemId={itemId} topic={topic} dataMethod={getReasonCodesNameWithPagination} selectedItem={selectedItem}>
        <ItemContentTabTwo>
            <SimpleItemDetails
                breadcrumb={breadcrumb}
                busy={busy}
                getTabContent={() => { }}
                itemProfile={currentItem}
                onBack={() => history.push(allItemsPath)}
                saveDetails={saveReasonCode}
                tabs={[]}
                initialValues={currentItem}
                children={
                    <ReasonCodeCard />} />
        </ItemContentTabTwo>
    </TopicContextProvider>
}

export default ReasonCode;
